module.exports = __webpack_public_path__ + "static/media/D_23_L.5f9318f2.png";